import Image from 'app/Components/Shared/Image/image';
import BusinessInvoicesContext, {AccountType, AccountTypeName} from 'app/Components/Page/BusinessInvoicesPage/BusinessInvoicesContext';
import React, {FC, memo, useContext} from 'react';
import Config from 'app/Config';
import {DomainMarketCode, getMarketCode} from 'app/utilities/domain/domainConstants';

const IntlNumber =
  typeof Intl != 'undefined'
    ? new Intl.NumberFormat('he-IL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : null;

const IntlDate = typeof Intl != 'undefined' ? new Intl.DateTimeFormat('he-IL', {year: 'numeric', month: '2-digit', day: '2-digit'}) : null;

const Format = {
  Currency: (value: number) => {
    const symbol = value < 0 ? '−₪' : '₪';
    const [val, digits] = IntlNumber.format(Math.abs(value)).split('.');

    return (
      <>
        {symbol}
        <b>{val}</b>.{digits}
      </>
    );
  },
  Date: (value: string) => IntlDate.format(new Date(value)),
};

interface InvoicesResultProps {
  digitalInvoicePage?: string;
}

const BusinessInvoicesResults: FC<InvoicesResultProps> = (props): JSX.Element => {
  const [{invoices}, dispatch] = useContext(BusinessInvoicesContext);

  const marketCode = getMarketCode();
  const OpenEmailOrPdfTab = (invoice) => {
    if (marketCode == DomainMarketCode.GOLAN) {
      invoice.checked = !invoice.checked;
      dispatch({type: 'checked'});
      return;
    }

    if (invoice.invoiceAccountType == AccountType[AccountType.Netvision]) {
      dispatch({type: 'open-email', invoices: [invoice]});
    } else {
      const linkUrl = `${Config.staticWebSiteUrl}${props.digitalInvoicePage}?id=${invoice.invoiceGuid}`;
      window.location.href = linkUrl;
    }
  };

  const getProviderName = (invoiceAccountType) => {
    const marketCode = getMarketCode();
    if(marketCode == DomainMarketCode.GOLAN){
      return AccountTypeName['Golan'];
    }

    return AccountTypeName[invoiceAccountType];
  };
  return invoices == null ? null : (
    <div className='BusinessInvoicesResults'>
      {invoices.map((invoice, i) => (
        <div className='BusinessInvoicesResults__result' key={i}>
          <div className='grid'>
            <div className='grid-action grid-action-checkbox'>
              <input
                id={`BusinessInvoicesResults__result__${i}`}
                type='checkbox'
                onChange={(e) => {
                  invoice.checked = e.currentTarget.checked;
                  dispatch({type: 'checked'});
                }}
              />
              <label htmlFor={`BusinessInvoicesResults__result__${i}`}>
                <div className='checkbox-wrapper'>
                  <Image src={require('./images/icons-checkbox.svg')} />
                </div>
              </label>
            </div>
            <div className='grid-items' onClick={() => OpenEmailOrPdfTab(invoice)}>
              <div className='BusinessInvoicesResults__provider'>{getProviderName(invoice.invoiceAccountType)}</div>
              <div className='BusinessInvoicesResults__price'>{Format.Currency(invoice.invoiceAmount)}</div>
              <div className='BusinessInvoicesResults__dates'>{invoice.invoiceFullDate}</div>

              <div className='grid-inner'>
                <div className='grid-items-inner'>
                  <div className='BusinessInvoicesResults__key'>מס׳ חשבונית</div>
                  <div className='BusinessInvoicesResults__value'>{invoice.invoiceNumber}</div>
                </div>
                <div className='grid-items-inner'>
                  <div className='BusinessInvoicesResults__key'>מס׳ חשבון</div>
                  <div className='BusinessInvoicesResults__value'>{invoice.accountNumber}</div>
                </div>
                <div className='grid-items-inner'>
                  <div className='BusinessInvoicesResults__key'>תאריך פרעון</div>
                  <div className='BusinessInvoicesResults__value'>{Format.Date(invoice.paymentDate)}</div>
                </div>
              </div>
            </div>
            {
              marketCode == DomainMarketCode.CELLCOM && (
                <div className='grid-action grid-action-pdf'>
                  <Image src={require('./images/icons-arrow-open.svg')} alt='חץ' onClick={() => OpenEmailOrPdfTab(invoice)} />
                </div>
              )
           }
          </div>
        </div>
      ))}
    </div>
  );
};

export default memo(BusinessInvoicesResults);
